import { el } from "../atoms/dom";

export function statCard(
  label: string,
  value: string,
  tone: "blue" | "cyan" | "amber" | "violet",
) {
  return el(
    "article",
    { className: `stat-card stat-card--${tone}` },
    el("span", { className: "stat-card__label", text: label }),
    el("strong", { className: "stat-card__value", text: value }),
  );
}
